import Vue from 'vue'
import VueRouter from 'vue-router'
import multiguard from 'vue-router-multiguard'

import auth from '../middleware/auth'
import guest from '../middleware/guest'
import groupAccess from '../middleware/groupAccess'
import defaultRoute from '../middleware/defaultRoute'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/login',
      name: 'login',
      component: () => import('@/views/Login.vue'),
      beforeEnter: multiguard([guest]),
      meta: {
        layout: 'full',
        resource: 'Auth',
        redirectIfLoggedIn: true,
      },
    },
    {
      path: '/',
      name: 'home',
      component: () => import('@/views/Home.vue'),
      beforeEnter: multiguard([auth, defaultRoute]),
      meta: {},
    },
    {
      path: '/crete-order',
      name: 'create-order',
      component: () => import('@/views/Orders/CreateOrder.vue'),
      beforeEnter: multiguard([auth, groupAccess('orders')]),
      meta: {},
    },
    {
      path: '/manual-order',
      name: 'manual-order',
      component: () => import('@/views/Orders/ManualOrder.vue'),
      beforeEnter: multiguard([auth, groupAccess('orders')]),
      meta: {},
    },
    {
      path: '/orders-uploads',
      name: 'orders-uploads',
      component: () => import('@/views/Orders/Uploads.vue'),
      beforeEnter: multiguard([auth, groupAccess('orders')]),
      meta: {},
    },
    {
      path: '/purchase-orders',
      name: 'purchase-orders',
      component: () => import('@/views/Orders/PurchaseOrders.vue'),
      beforeEnter: multiguard([auth, groupAccess('orders')]),
      meta: {},
    },
    {
      path: '/purchase-order-summary',
      name: 'purchase-order-summary',
      component: () => import('@/views/Orders/PurchaseOrderSummary.vue'),
      beforeEnter: multiguard([auth, groupAccess('orders')]),
      meta: {},
    },
    {
      path: '/shortage-items',
      name: 'shortage-items',
      component: () => import('@/views/Orders/ShortageItemList.vue'),
      beforeEnter: multiguard([auth, groupAccess('orders')]),
      meta: {},
    },
    {
      path: '/uploads',
      name: 'uploads',
      component: () => import('@/views/Accounts/Uploads.vue'),
      beforeEnter: multiguard([auth, groupAccess('accounts')]),
      meta: {},
    },
    {
      path: '/dashboard',
      name: 'dashboard',
      component: () => import('@/views/Accounts/Dashboard.vue'),
      beforeEnter: multiguard([auth, groupAccess('accounts')]),
      meta: {},
    },
    {
      path: '/statements',
      name: 'statements',
      component: () => import('@/views/Accounts/Statements.vue'),
      beforeEnter: multiguard([auth, groupAccess('accounts')]),
      meta: {},
    },
    {
      path: '/print-statements',
      name: 'print-statements',
      component: () => import('@/views/Accounts/PrintStatements.vue'),
      beforeEnter: multiguard([auth, groupAccess('accounts')]),
      meta: {},
    },
    {
      path: '/credit-debit-notes',
      name: 'credit-debit-notes',
      component: () => import('@/views/Accounts/CreditDebitNotes.vue'),
      beforeEnter: multiguard([auth, groupAccess('accounts')]),
      meta: {},
    },
    {
      path: '/defualt-parties',
      name: 'defualt-parties',
      component: () => import('@/views/Accounts/DefaultParties.vue'),
      beforeEnter: multiguard([auth, groupAccess('accounts')]),
      meta: {},
    },
    {
      path: '/party-ledger',
      name: 'party-ledger',
      component: () => import('@/views/Accounts/PartyLedger.vue'),
      beforeEnter: multiguard([auth, groupAccess('accounts')]),
      meta: {},
    },
    {
      path: '/compare-ledger',
      name: 'compare-ledger',
      component: () => import('@/views/Accounts/CompareLedger.vue'),
      beforeEnter: multiguard([auth, groupAccess('accounts')]),
      meta: {},
    },
    {
      path: '/cheques',
      name: 'cheques',
      component: () => import('@/views/Accounts/Cheques.vue'),
      beforeEnter: multiguard([auth, groupAccess('accounts')]),
      meta: {},
    },
    {
      path: '/issued-cheques',
      name: 'issued-cheques',
      component: () => import('@/views/Accounts/IssuedCheques.vue'),
      beforeEnter: multiguard([auth, groupAccess('accounts')]),
      meta: {},
    },
    {
      path: '/outstanding-report',
      name: 'outstanding-report',
      component: () => import('@/views/Accounts/OutstandingReport.vue'),
      beforeEnter: multiguard([auth, groupAccess('accounts')]),
      meta: {},
    },
    {
      path: '/sales-schedule',
      name: 'sales-schedule',
      component: () => import('@/views/Accounts/SalesSchedule.vue'),
      beforeEnter: multiguard([auth, groupAccess('sales')]),
      meta: {},
    },
    {
      path: '/sales-targets',
      name: 'sales-targets',
      component: () => import('@/views/Accounts/SalesTargets.vue'),
      beforeEnter: multiguard([auth, groupAccess('accounts')]),
      meta: {},
    },
    {
      path: '/online-payments',
      name: 'online-payments',
      component: () => import('@/views/Accounts/OnlinePayments.vue'),
      beforeEnter: multiguard([auth, groupAccess('accounts')]),
    },
    {
      path: '/salary',
      name: 'salary',
      component: () => import('@/views/Accounts/Salary.vue'),
      beforeEnter: multiguard([auth, groupAccess('salary')]),
    },
    {
      path: '/default-party-order-requests',
      name: 'default-party-order-requests',
      component: () => import('@/views/Accounts/DefaultPartyOrderRequest.vue'),
      beforeEnter: multiguard([auth, groupAccess('accounts')]),
      meta: {},
    },
    {
      path: '/todays-bills',
      name: 'todays-bills',
      component: () => import('@/views/Accounts/TodaysBills.vue'),
      beforeEnter: multiguard([auth, groupAccess('sales')]),
      meta: {},
    },
    {
      path: '/sales-notifications',
      name: 'sales-notifications',
      component: () => import('@/views/Sales/SalesNotifications.vue'),
      beforeEnter: multiguard([auth, groupAccess('sales')]),
    },
    {
      path: '/orders',
      name: 'orders',
      component: () => import('@/views/Sales/Orders.vue'),
      beforeEnter: multiguard([auth, groupAccess('sales')]),
      meta: {},
    },
    {
      path: '/mr-list',
      name: 'mr-list',
      component: () => import('@/views/Sales/MrList.vue'),
      beforeEnter: multiguard([auth, groupAccess('sales')]),
      meta: {},
    },
    {
      path: '/pob',
      name: 'pob',
      component: () => import('@/views/Sales/Pobs.vue'),
      beforeEnter: multiguard([auth, groupAccess('sales')]),
      meta: {},
    },
    {
      path: '/special-bonus',
      name: 'special-bonus',
      component: () => import('@/views/Sales/SpecialBonus.vue'),
      beforeEnter: multiguard([auth, groupAccess('sales')]),
      meta: {},
    },
    {
      path: '/item-discount',
      name: 'item-discount',
      component: () => import('@/views/Sales/ItemDiscount.vue'),
      beforeEnter: multiguard([auth, groupAccess('sales')]),
      meta: {},
    },
    {
      path: '/monthly-targets',
      name: 'monthly-targets',
      component: () => import('@/views/Sales/MonthlyTargets.vue'),
      beforeEnter: multiguard([auth, groupAccess('sales')]),
      meta: {},
    },
    {
      path: '/lead-management',
      name: 'lead-management',
      component: () => import('@/views/Sales/LeadManagement.vue'),
      beforeEnter: multiguard([auth, groupAccess('sales')]),
      meta: {},
    },
    {
      path: '/supplier-return',
      name: 'supplier-return',
      component: () => import('@/views/Returns/SupplierReturn.vue'),
      beforeEnter: multiguard([auth, groupAccess('returns')]),
      meta: {},
    },
    {
      path: '/supplier-return-summary',
      name: 'supplier-return-summary',
      component: () => import('@/views/Returns/SupplierReturnSummary.vue'),
      beforeEnter: multiguard([auth, groupAccess('returns')]),
      meta: {},
    },
    {
      path: '/supplier-return-matrix',
      name: 'supplier-return-matrix',
      component: () => import('@/views/Returns/SupplierReturnMatrix.vue'),
      beforeEnter: multiguard([auth, groupAccess('returns')]),
      meta: {},
    },
    {
      path: '/buyer-return',
      name: 'buyer-return',
      component: () => import('@/views/Returns/BuyerReturn.vue'),
      beforeEnter: multiguard([auth, groupAccess('returns')]),
      meta: {},
    },
    {
      path: '/expiry-label',
      name: 'expiry-label',
      component: () => import('@/views/Returns/ExpiryLabel.vue'),
      beforeEnter: multiguard([auth, groupAccess('returns')]),
      meta: {},
    },
    {
      path: '/bilty',
      name: 'bilty',
      component: () => import('@/views/Invoices/Bilty.vue'),
      beforeEnter: multiguard([auth, groupAccess('invoices')]),
      meta: {},
    },
    {
      path: '/invoices',
      name: 'invoices',
      component: () => import('@/views/Invoices/Invoices.vue'),
      beforeEnter: multiguard([auth, groupAccess('invoices')]),
      meta: {},
    },
    {
      path: '/capital-goods-invoice',
      name: 'capital-goods-invoice',
      component: () => import('@/views/Invoices/CapitalGoodsInvoice.vue'),
      beforeEnter: multiguard([auth, groupAccess('invoices')]),
      meta: {},
    },
    {
      path: '/supplier-tickets',
      name: 'supplier-tickets',
      component: () => import('@/views/Tickets/SupplierTickets.vue'),
      beforeEnter: multiguard([auth, groupAccess('tickets')]),
      meta: {},
    },
    {
      path: '/buyer-tickets',
      name: 'buyer-tickets',
      component: () => import('@/views/Tickets/BuyerTickets.vue'),
      beforeEnter: multiguard([auth, groupAccess('tickets')]),
      meta: {},
    },
    {
      path: '/purchase-items-stock',
      name: 'purchase-items-stock',
      component: () => import('@/views/Stocks/PurchaseItemStock.vue'),
      beforeEnter: multiguard([auth, groupAccess('stocks')]),
    },
    {
      path: '/verified-stock-reports',
      name: 'verified-stock-reports',
      component: () => import('@/views/Stocks/VerifiedStockReports.vue'),
      beforeEnter: multiguard([auth, groupAccess('stocks')]),
    },
    {
      path: '/minimum-quantity',
      name: 'minimum-quantity',
      component: () => import('@/views/Stocks/MinimumQuantityList.vue'),
      beforeEnter: multiguard([auth, groupAccess('stocks')]),
    },
    {
      path: '/delivery-access-management',
      name: 'delivery-access-management',
      component: () => import('@/views/Delivery/AccessManagement.vue'),
      beforeEnter: multiguard([auth, groupAccess('delivery_admin')]),
    },
    {
      path: '/delivery-status',
      name: 'delivery-status',
      component: () => import('@/views/Delivery/DeliveryStatus.vue'),
      beforeEnter: multiguard([auth, groupAccess('delivery_admin')]),
    },
    {
      path: '/delivery-dashboard',
      name: 'delivery-dashboard',
      component: () => import('@/views/Delivery/DeliveryDashboard.vue'),
      beforeEnter: multiguard([auth, groupAccess('delivery_admin')]),
    },
    {
      path: '/bus-master',
      name: 'bus-master',
      component: () => import('@/views/Delivery/BusMaster.vue'),
      beforeEnter: multiguard([auth, groupAccess('delivery_admin')]),
    },
    {
      path: '/retailer-insights',
      name: 'retailer-insights',
      component: () => import('@/views/Retailers/RetailerInsights.vue'),
      beforeEnter: multiguard([auth, groupAccess('retailer_admin')]),
    },
    {
      path: '/retailer-tickets',
      name: 'retailer-tickets',
      component: () => import('@/views/Retailers/RetailerTickets.vue'),
      beforeEnter: multiguard([auth, groupAccess('retailer_admin')]),
    },
    {
      path: '/retailer-banners',
      name: 'retailer-banners',
      component: () => import('@/views/Retailers/Banners.vue'),
      beforeEnter: multiguard([auth, groupAccess('retailer_admin')]),
    },
    {
      path: '/retailer-notifications',
      name: 'retailer-notifications',
      component: () => import('@/views/Retailers/Notifications.vue'),
      beforeEnter: multiguard([auth, groupAccess('retailer_admin')]),
    },
    {
      path: '/retailer-orders',
      name: 'retailer-orders',
      component: () => import('@/views/Retailers/RetailerOrders.vue'),
      beforeEnter: multiguard([auth, groupAccess('retailer_admin')]),
    },
    {
      path: '/retailer-shortage-items',
      name: 'retailer-shortage-items',
      component: () => import('@/views/Retailers/RetailerShortageItemList.vue'),
      beforeEnter: multiguard([auth, groupAccess('retailer_admin')]),
      meta: {},
    },
    {
      path: '/rack-group-reports',
      name: 'rack-group-reports',
      component: () => import('@/views/Operations/RackGroupReports.vue'),
      beforeEnter: multiguard([auth, groupAccess('operations')]),
    },
    {
      path: '/verify-order-items',
      name: 'verify-order-items',
      component: () => import('@/views/Operations/VerifyOrderItems.vue'),
      beforeEnter: multiguard([auth, groupAccess('operations')]),
    },
    {
      path: '/packing',
      name: 'packing',
      component: () => import('@/views/Operations/Packing.vue'),
      beforeEnter: multiguard([auth, groupAccess('operations')]),
    },
    {
      path: '/cash-register',
      name: 'cash-register',
      component: () => import('@/views/Operations/CashRegister.vue'),
      beforeEnter: multiguard([auth, groupAccess('operations_cashreg')]),
    },
    {
      path: '/operations-dashboard',
      name: 'operations-dashboard',
      component: () => import('@/views/Operations/Dashboard.vue'),
      beforeEnter: multiguard([auth, groupAccess('operations_admin')]),
    },
    {
      path: '/bulk-mailing/add',
      name: 'bulk-mailing-add',
      component: () => import('@/views/Communication/EmailSendPage.vue'),
      beforeEnter: multiguard([auth, groupAccess('communications')]),
    },
    {
      path: '/mail-templates',
      name: 'mail-templates',
      component: () => import('@/views/Communication/MailTemplates.vue'),
      beforeEnter: multiguard([auth, groupAccess('communications')]),
    },
    {
      path: '/error-404',
      name: 'error-404',
      component: () => import('@/views/error/Error404.vue'),
      meta: {
        layout: 'full',
        resource: 'Auth',
        action: 'read',
      },
    },
    {
      path: '/error-403',
      name: 'error-403',
      component: () => import('@/views/error/Error403.vue'),
      meta: {
        layout: 'full',
        resource: 'Auth',
        action: 'read',
      },
    },
    {
      path: '*',
      redirect: 'error-404',
    },
  ],
})

// ? For splash screen
// Remove afterEach hook if you are not using splash screen
router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = 'none'
  }
})

export default router
